"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SlideUp = _interopRequireDefault(require("../../animations/SlideUp"));

var _BrandButton = _interopRequireDefault(require("../Button/BrandButton"));

var _OutlineButton = _interopRequireDefault(require("../Button/OutlineButton"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _zIndex = _interopRequireDefault(require("../../constants/z-index"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin-left: ", ";\n\t", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin-left: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tmargin-left: auto;\n\talign-items: center;\n\tpadding-left: ", ";\n\tmargin-top: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin-top: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\twidth: 100%;\n\talign-items: center;\n\tflex-wrap: wrap;\n\tmargin-top: -", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground: ", ";\n\tcolor: ", ";\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tflex-wrap: no-wrap;\n\n\tpadding: 0.75rem;\n\tborder-radius: 2px;\n\tfont-size: 0.875rem;\n\tbox-shadow: 0px 2px 4px hsla(0, 0%, 0%, 0.25);\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tleft: 0;\n\tbottom: 0;\n\tmin-width: 300px;\n\tmax-width: 600px;\n\tmargin: 0.5rem;\n\tz-index: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var typeColours = {
  basic: _colors.default.snackbar.BASIC,
  information: _colors.default.snackbar.INFORMATION,
  success: _colors.default.snackbar.SUCCESS,
  error: _colors.default.snackbar.ERROR
};
var SlideUpLeft = (0, _styledComponents.default)(_SlideUp.default)(_templateObject(), _zIndex.default.OVERLAY);
SlideUpLeft.displayName = 'SlideUpLeft';

var SnackWrapper = _styledComponents.default.div(_templateObject2(), function (props) {
  return typeColours[props.type];
}, function (props) {
  return props.type === 'basic' ? '#333' : '#FFF';
});

SnackWrapper.displayName = 'SnackWrapper';

var ContentWrapper = _styledComponents.default.div(_templateObject3(), _spacing.default.s2);

ContentWrapper.displayName = 'ContentWrapper';

var Content = _styledComponents.default.div(_templateObject4(), _spacing.default.s2);

Content.displayName = 'Content';

var ActionWrapper = _styledComponents.default.div(_templateObject5(), _spacing.default.s3, _spacing.default.s2);

ActionWrapper.displayName = 'ActionWrapper';

var Actions = _styledComponents.default.div(_templateObject6(), _spacing.default.s1);

Actions.displayName = 'Action';
var ToastBrandButton = (0, _styledComponents.default)(_BrandButton.default)(_templateObject7(), function (props) {
  return props.type !== 'basic' && "\n\t\t\tcolor: " + typeColours[props.type] + ";\n\t\t\tbackground-color: white;\n\t\t\tborder-color: transparent;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tcolor: " + typeColours[props.type] + ";\n\t\t\t\t\tbackground-color: white;\n\t\t\t\t\tborder-color: transparent;\n\t\t\t\t}\n\n\t\t";
});
ToastBrandButton.displayName = 'ToastBrandButton';
var ToastOutlineButton = (0, _styledComponents.default)(_OutlineButton.default)(_templateObject8(), _spacing.default.s1, function (props) {
  return props.type !== 'basic' && "\n\t\t\tbackground-color: transparent;\n\t\t\tcolor: white;\n\t\t\tborder-color: white;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: transparent;\n\t\t\t\tborder-color: white;\n\t\t\t}\n\t";
});
ToastOutlineButton.displayName = 'ToastOutlineButton';
var delays = {
  short: 3000,
  medium: 7500,
  long: 10000
};

var Snackbar =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Snackbar, _React$Component);

  function Snackbar(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    (0, _reactAutobind.default)(_assertThisInitialized(_this));
    _this.timer = null;
    return _this;
  }

  var _proto = Snackbar.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.visible) {
      this.hideAfterDelay();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      this.hideAfterDelay();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.clearTimeout(this.timer);
  };

  _proto.hideAfterDelay = function hideAfterDelay() {
    var _this$props = this.props,
        displayTime = _this$props.displayTime,
        onClose = _this$props.onClose;

    if (displayTime !== 'persistent') {
      var delay = delays[displayTime];
      this.timer = window.setTimeout(function () {
        onClose();
      }, delay);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        visible = _this$props2.visible,
        children = _this$props2.children,
        onClose = _this$props2.onClose,
        hideClose = _this$props2.hideClose,
        action = _this$props2.action,
        onAction = _this$props2.onAction,
        displayTime = _this$props2.displayTime,
        type = _this$props2.type,
        rest = _objectWithoutPropertiesLoose(_this$props2, ["visible", "children", "onClose", "hideClose", "action", "onAction", "displayTime", "type"]);

    return (0, _reactDom.createPortal)(_react.default.createElement(SlideUpLeft, _extends({
      visible: visible
    }, rest), _react.default.createElement(SnackWrapper, {
      type: type,
      "data-testid": "snackwrapper"
    }, _react.default.createElement(ContentWrapper, null, _react.default.createElement(Content, {
      hideClose: hideClose
    }, children), _react.default.createElement(ActionWrapper, null, _react.default.createElement(Actions, null, onAction && _react.default.createElement(ToastBrandButton, {
      type: type,
      onClick: function onClick() {
        onAction();
        onClose();
      }
    }, action), displayTime === 'persistent' && _react.default.createElement(ToastOutlineButton, {
      type: type,
      onClick: onClose
    }, "Dismiss")))))), document.body);
  };

  return Snackbar;
}(_react.default.Component);

Snackbar.displayName = 'Snackbar';
Snackbar.propTypes = {
  type: (0, _propTypes.oneOf)(['basic', 'information', 'success', 'error']),
  visible: _propTypes.bool.isRequired,
  children: _propTypes.node.isRequired,
  onClose: _propTypes.func.isRequired,
  hideClose: _propTypes.bool,
  displayTime: (0, _propTypes.oneOf)(['short', 'medium', 'long', 'persistent']),
  action: _propTypes.string,
  onAction: _propTypes.func
};
Snackbar.defaultProps = {
  type: 'basic',
  displayTime: 'medium',
  hideClose: false,
  action: undefined,
  onAction: undefined
};
var _default = Snackbar;
exports.default = _default;